import SmoothScroll from 'smooth-scroll'

let scroll = new SmoothScroll('a[href*="#"]')